module.exports = __webpack_public_path__ + "_assets/img/cloud.f087696b.svg";